import React, { useState, useEffect } from "react";
import useSWR from "swr";
import axios from "axios";

import Main from "components/templates/m/portfolio/Main";
import useUserProfile from "utils/clientAPIs/userProfile";
import usePortfolioPrices from "utils/clientAPIs/portfolioPrices";
import NoPort from "components/templates/common/Portfolio/NoPort";

function Portfolio({ session, isUserAndNoPort }: any) {
  const [userProfile, isValidating, mutate] = useUserProfile();
  const userPortfolio = userProfile?.portfolios ? userProfile?.portfolios : [];
  const [portfolioPrices, portMutate] = usePortfolioPrices(userPortfolio);

  return (
    <main className="min-w-[360px] h-auto ">
      {!session || isUserAndNoPort ? (
        <div className="bg-white">
          <NoPort session={session} />
        </div>
      ) : (
        <Main userProfile={userProfile} portfolios={portfolioPrices} />
      )}
    </main>
  );
}

export default Portfolio;
